export const toUSD = (num: number) => {
  return parseFloat(
    String(num)
      .split("")
      .map((e, i, a) => (i === a.length - 2 ? "." + e : e))
      .join(""),
  ).toLocaleString("en-US", {
    style: "currency",
    currency: "USD",
  });
};

export const toDateString = (date: Date) => {
  return date.toLocaleDateString("en-US", {
    year: "numeric",
    month: "short",
    day: "numeric",
  });
};
